import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/assets/logo.png'


const _hoisted_1 = { id: "banner" }
const _hoisted_2 = {
  id: "items-wrapper",
  class: "flex items-center"
}
const _hoisted_3 = {
  id: "nav-head",
  class: "flex items-center justify-between"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "CoderJo's Cross Logo",
  id: "logo"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h1", null, "CoderJo", -1)
const _hoisted_6 = {
  for: "menu-button-input",
  id: "menu-button",
  class: "flex justify-center items-center hover-hint"
}
const _hoisted_7 = ["show"]
const _hoisted_8 = { id: "nav-list" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", {
  id: "nav-bar-img",
  src: _imports_0,
  alt: "CoderJo's Cross Logo"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_iconify_icon = _resolveComponent("iconify-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          id: "title-wrap",
          class: "items-center hover-hint",
          to: _ctx.locations[0].route
        }, {
          default: _withCtx(() => [
            _hoisted_4,
            _hoisted_5
          ]),
          _: 1
        }, 8, ["to"]),
        _withDirectives(_createElementVNode("input", {
          id: "menu-button-input",
          class: "display-none",
          type: "checkbox",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.toggleNavBar) = $event))
        }, null, 512), [
          [_vModelCheckbox, _ctx.toggleNavBar]
        ]),
        _createElementVNode("label", _hoisted_6, [
          _createVNode(_component_iconify_icon, {
            mode: "svg",
            icon: _ctx.toggleNavBar ? 'line-md:menu-to-close-transition' : 'line-md:close-to-menu-alt-transition'
          }, null, 8, ["icon"])
        ])
      ]),
      _createElementVNode("nav", {
        id: "nav-bar",
        show: _ctx.toggleNavBar ? '' : undefined
      }, [
        _createElementVNode("ul", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locations, (location) => {
            return (_openBlock(), _createElementBlock("li", null, [
              _createVNode(_component_router_link, {
                class: "items-center hover-hint",
                to: location.route
              }, {
                default: _withCtx(() => [
                  _createElementVNode("p", null, [
                    _createElementVNode("b", null, _toDisplayString(_ctx.$t("bannerNavList." + location.key)), 1)
                  ])
                ]),
                _: 2
              }, 1032, ["to"])
            ]))
          }), 256))
        ]),
        _hoisted_9
      ], 8, _hoisted_7)
    ])
  ]))
}